import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_22qxjttyk7: FaireBrandEntity = {
  token: "b_22qxjttyk7",
  type: "brand",
  name: "NuEats",
  avatarUrl:
    "https://cdn.faire.com/fastly/6e9b14abd2436b414ffea91d2d537021de530b8eb49ea6f631ad81fe931ac112.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e6a458694b1aac29f62f87a18db602cf033b46da17723ecd426603e62a746ad7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6e9b14abd2436b414ffea91d2d537021de530b8eb49ea6f631ad81fe931ac112.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e6a458694b1aac29f62f87a18db602cf033b46da17723ecd426603e62a746ad7.png",
  location: "Carlstadt, NJ, USA",
  minimumOrderDollars: 42,
  rating: 4.7,
  reviewCount: 13,
  isInsider: true,
  description:
    "A moment in Taste!\n\nNuEats Promotes the consumption of organic / natural foods and beverages. \nWe hope our products satisfy customer's daily nutritional needs. \n\nOur brand, NuEats has about 100 products(Organic Coffee roasted in NYC, FreshCode grains, Organic Coconut oil, Organic Chocolate..etc.)  and we are keep developing our products. \n\nVisit our website to see our products. \n\nwww.nueats.co",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.058Z",
    importedBy: "entity-db-cli",
  },
};
